import { httpClient as http } from '@/utils/http'
import type {
  ApiResponse,
  PageResponse,
  BatchDeleteRequest,
  BatchUpdatePriceRequest,
  BatchModifyHeaderRequest,
  BatchModifyResult,
  PricePrePortPageRequest,
  PricePrePortListVO,
  PricePrePortVO,
  PricePrePortSaveRequest,
  PricePrePortUpdateRequest,
  PricePrePortBatchDetailVO,
  PricePrePortMatchTrunkRequest,
  PricePrePortMatchTrunkVO,
  PriceBatchSaveRequest,
  PriceBatchSaveResultVO
} from './types'

// 分页查询港前运价
export const page = (params: PricePrePortPageRequest) => {
  return http.post<PageResponse<PricePrePortListVO>>('/price/pre-port/page', params)
}

// 新增港前运价
export const save = (params: PricePrePortSaveRequest) => {
  return http.post<boolean>('/price/pre-port/save', params)
}

/** 批量新增港前运价（多区域新建，CCTOWER-2468） */
export const batchSave = (params: PriceBatchSaveRequest<PricePrePortSaveRequest>) => {
  return http.post<PriceBatchSaveResultVO>('/price/pre-port/batch-save', params)
}

// 修改港前运价
export const update = (params: PricePrePortUpdateRequest) => {
  return http.post<boolean>('/price/pre-port/update', params)
}

// 获取港前运价详情
export const get = (id: string) => {
  return http.post<ApiResponse<PricePrePortVO>>('/price/pre-port/get', { id })
}

/** 匹配干线运价（港前→干线，结果不落库） */
export const matchTrunk = (params: PricePrePortMatchTrunkRequest) => {
  return http.post<PricePrePortMatchTrunkVO>('/price/pre-port/match-trunk', params)
}

// 批量上架港前运价
export const batchOnline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/pre-port/batch-online', params)
}

export const precheckBatchOnline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/pre-port/batch-online-precheck', params)
}

export const precheckBatchOffline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/pre-port/batch-offline-precheck', params)
}

export const precheckBatchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/pre-port/batch-delete-precheck', params)
}

// 批量下架港前运价
export const batchOffline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/pre-port/batch-offline', params)
}

// 批量删除港前运价
export const batchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/pre-port/batch-delete', params)
}

// 批量修改价格
export const batchUpdatePrice = (params: BatchUpdatePriceRequest) => {
  return http.post<boolean>('/price/pre-port/batch-update-price', params)
}

// 根据IDs查询运价明细（批量改价用）
export const getBatchPriceDetails = (params: BatchDeleteRequest) => {
  return http.post<ApiResponse<PricePrePortBatchDetailVO[]>>(
    '/price/pre-port/batch-price-details',
    params
  )
}

// 批量修改有效期
export const batchUpdateValidDate = (params: any) => {
  return http.post<boolean>('/price/pre-port/batch-update-valid-date', params)
}

// 批量修改时间（ETD/ETA）
export const batchUpdateTime = (params: any) => {
  return http.post<boolean>('/price/pre-port/batch-update-time', params)
}

// 批量修改表头字段
export const batchModify = (params: BatchModifyHeaderRequest) => {
  return http.post<BatchModifyResult>('/price/pre-port/batch-modify', params)
}